import Image from 'next/image';
import Link from 'next/link';

const interworkyLinks = [
  { name: 'Product', link: '/product' },
  { name: 'About', link: '/#about' },
  { name: 'Carbon Commitment', link: 'https://climate.stripe.com/lKGmQn' },
];

const supportLinks = [
  { name: 'Email', link: 'mailto:hello@interworky.com' },
  { name: 'Compliance', link: '/compliance' },
  { name: 'Security', link: '/compliance#security' },
  { name: 'Login', link: '/login' },
];

const FooterSection = ({ isLanding = false }) => {
  const logoSrc = isLanding ? '/dark-logo.png' : '/finallogo.png';
  return (
    <footer
      className={`${isLanding ? 'pt-20 pb-10 px-20 bg-black text-white flex flex-col gap-20' : 'bg-white text-black rounded-lg shadow pt-20 pb-10 px-20'}`}
    >
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div className="flex-shrink-0">
          <Link href="/">
            <Image src={logoSrc} alt="interworky-logo" width={245} height={35} />
          </Link>
        </div>
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-12">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
            <span className="text-gray-400 font-semibold text-sm uppercase tracking-wide">Company</span>
            <div className="flex flex-wrap items-center gap-6">
              {interworkyLinks.map((link, i) => (
                <Link key={i} href={link.link} className="hover:opacity-80 transition-opacity text-sm">
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
            <span className="text-gray-400 font-semibold text-sm uppercase tracking-wide">Support</span>
            <div className="flex flex-wrap items-center gap-6">
              {supportLinks.map((link, i) => (
                <Link key={i} href={link.link} className="hover:opacity-80 transition-opacity text-sm">
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className=" border-t-2 border-gray-700 m-4">
        <div className="flex flex-wrap items-center justify-center gap-20 pt-10 text-lg">
          <div>© 2025 MultiSync Inc.</div>
          <div>
            <Link href={'/privacy'} className="underline">
              Privacy Policy
            </Link>
          </div>
          <div>
            <Link href={'/terms'} className="underline">
              {' '}
              Terms of services
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
